module.exports = __webpack_public_path__ + "img/2f892859.png";